<ul class="media-body m-0 p-0">
    @for(document of documents; track document ){
        <li>
            <a href="javascript:void(0);" class="fw-bold text-overflow text-dark mb-0" (click)="navigateToDocumentDetails(document)">
                {{ document.visible_name }}
            </a>
        </li>
        }
</ul>